// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BdVgF","type":"styles_type__2g-8E","choices":"styles_choices__tAqhl"};